import React from 'react';
import * as Utils from "../../inc/Utils";
import toast, { Toaster } from 'react-hot-toast';

import {confirmAlert} from "react-confirm-alert";
import Role from "../../inc/Role";
import {NavLink, useParams, useNavigate} from "react-router-dom";
import * as Icon from "react-bootstrap-icons";
import {Config} from '../../Config'
import moment from "moment-timezone";

export default function AdsNamingEdit() {
    let {encode} = useParams();
    let decode = Utils.decodeItem(encode);
    let utmId = decode.id;

    const roles = new Role();
    let userId = roles.loginUserId;

    let btnTextDefault = 'อัพเดตข้อมูล';
    let btnTextLoading = 'กำลังอัพเดต..';
    let [isLoading, setLoading] = React.useState(false);
    let [data, setData] = React.useState('');
    let [statusChecked, setStatusChecked] = React.useState(false);
    let [selectedType, setSelectedType] = React.useState(false);
    const navigate = useNavigate();

    let refName = React.useRef(); 

    React.useEffect(() => {
        (async function() {
            try {
                const resView = await getView();
                setData(resView);
                setStatusChecked(resView.status===1);
                refName.current.value = resView.name;
                setSelectedType(resView.inputType);
            } catch (e) {
                toast.error(e.message);
            }
        })();
    }, []);

    async function getView() {
        const response = await fetch(Config.url.API_URL +'/api/adsNaming/view', {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                'x-access-token': roles.accessToken
            },
            body: JSON.stringify({
                id: utmId
            })
        });

        if(response.ok) {
            return response.json();
        }
        else {
            return response.json().then(err => Promise.reject(err));
        }
    }

    const onUpdate = () => {
        let name = refName.current.value; 
        if(!name) {
            toast.error("กรุณาระบุ ชื่อ Ads Naming");
            refName.current.focus();
        }
        else {
            confirmAlert({
                title: 'แจ้งเตือน',
                message: 'ต้องการอัพเดตข้อมูล ?',
                buttons: [
                    {
                        label: 'ตกลง',
                        onClick: () => {
                            setLoading(true);

                            let statusChecked = document.getElementsByName('statusChecked');

                            let items = [];
                            let checkboxes = document.getElementsByName('typeIds[]');
                            for (let i = 0; i < checkboxes.length; i++) {
                                if(checkboxes[i].checked) {
                                    items.push({'typeId': checkboxes[i].value});
                                }
                            }

                            const body = {
                                id: data.id,
                                name: name,
                                currentName: data.name,
                                status: statusChecked[0].checked ? 1:0,
                                inputType: selectedType ?? null,
                                updatedBy: userId,
                                updatedAt: moment().tz('Asia/Bangkok').format('YYYY-MM-DD HH:mm:ss'),
                                items: items
                            };
                            fetch(Config.url.API_URL +'/api/adsNaming/update', {
                                method: 'POST',
                                body: JSON.stringify(body),
                                headers: {
                                    'Content-Type':'application/json',
                                    'x-access-token': roles.accessToken
                                }
                            }).then(response => {
                                setLoading(false);
                                if(response.ok) {
                                    return response.json();
                                }
                                else {
                                    return response.json().then(err => Promise.reject(err));
                                }
                            }).then(result => {
                                if(result) {
                                    toast.success("อัพเดตข้อมูลเรียบร้อย");
                                    setTimeout(function () {
                                        navigate('/adsNaming', {replace: true});
                                    }, 1500);
                                }
                            }).catch(err => {
                                toast.error(err.message);
                            })
                        }
                    },
                    {
                        label: 'ยกเลิก',
                        onClick: () => {}
                    }
                ]
            });
        }
    };

    let checkedCampaign = false;
    let checkedSetName = false;

    if(data) {
        for(let item of data.items) {
            if(item.typeId) {
                if(item.typeId === Utils.ADSNAMING_TYPE_CAMPAIGN) {
                    data.checkedCampaign = true;
                }
                else if(item.typeId === Utils.ADSNAMING_TYPE_SETNAME) {
                    data.checkedSetName = true;
                }
                else if(item.typeId === Utils.ADSNAMING_TYPE_CREATIVE) {
                    data.checkedCreative = true;
                }
            }
        }
    }

    const onChangeInputType = (Id) => {
        setSelectedType(Id);
    };

    return (
        <main>
            <div className="row table-toolbar mb-2">
                <div className="col-6 align-self-center">
                    <div className="h6 d-inline"><span className="text-success">&#8226;</span> Master Ads Naming Format</div>
                    <span className="ms-1">/</span> <span className="text-muted">Edit</span>
                </div>
                <div className="col-6 text-end align-self-center toolbars">
                </div>
            </div>
            <div className="rounded bg-white p-4 shadow">
                <div className="row">
                    <div className="col-12 col-md-6">
                        <form className="row g-3">
                            <div className="col-12">
                                <label htmlFor="name" className="form-label">ชื่อ Ads Naming <span className="text-danger">*</span></label>
                                <input type="text" className="form-control" id="name" ref={refName} maxLength={100} />
                            </div>
                            <div className="col-12">
                                <label htmlFor="typeCampaignx" className="form-label">ประเภท</label>
                                <div className="form-check ms-2">
                                    <input className="form-check-input" name="typeIds[]" type="checkbox" value={Utils.ADSNAMING_TYPE_CAMPAIGN} id="typeCampaign" onClick={e => {checkedCampaign = e.target.checked;}} defaultChecked={data.checkedCampaign} />
                                    <label className="form-check-label" htmlFor="typeCampaign">Campaign</label>
                                </div>
                                <div className="form-check ms-2 mt-2">
                                    <input className="form-check-input" name="typeIds[]" type="checkbox" value={Utils.ADSNAMING_TYPE_SETNAME} id="typeSetName" onClick={e => {checkedSetName = e.target.checked;}} defaultChecked={data.checkedSetName} />
                                    <label className="form-check-label" htmlFor="typeSetName">Set Name</label>
                                </div>
                            </div>
                            <div className="col-12">
                                <label htmlFor="inputTypex" className="form-label">Input Type</label>
                                <select className="form-select" id="inputType" onChange={(event) => onChangeInputType(event.target.value)} value={selectedType ?? ''}>
                                    <option value="">Default/Dropdown</option>
                                    <option value={Utils.ADSNAMING_TYPE_SLUG_PROJECT}>Slug Project</option>
                                    <option value={Utils.ADSNAMING_TYPE_SLUG_PROMOTION}>Slug Promotion</option>
                                    <option value={Utils.ADSNAMING_TYPE_SLUG_SPECIAL}>Slug Special</option>
                                    <option value={Utils.ADSNAMING_TYPE_KOL_PAGE}>Kol Page</option>
                                    <option value={Utils.ADSNAMING_TYPE_FREEFORM}>Free Form</option>
                                </select>
                            </div>
                            <div className="col-12">
                                <label htmlFor="statusx" className="form-label">สถานะ</label>
                                <div className="form-check form-switch">
                                    <input className="form-check-input" type="checkbox" name="statusChecked" id="status" checked={statusChecked} onChange={e => {setStatusChecked(e.target.checked)}} />
                                    <label className="form-check-label" htmlFor="status"></label>
                                </div>
                            </div>
                            <div className="col-12">
                                <button type="button" className="btn btn-primary" onClick={onUpdate}><span
                                    className={isLoading ? 'spinner-grow spinner-grow-sm' : 'd-none'}></span> {isLoading ? btnTextLoading : btnTextDefault}</button>
                                <NavLink className="btn btn-sm btn-light ms-2" to='/adsNaming'><span><Icon.ArrowLeft/> กลับไป</span></NavLink>
                                <Toaster position="bottom-right" />
                            </div>
                        </form>
                    </div>
                    <div className="col-12 col-md-6"></div>
                </div>
            </div>
        </main>
    );
} 